<template>
  <div :style="{ height: bheight + 'px' }" class="f-flex f-flex-center">
    <img
      v-if="!isShangyun"
      width="300px"
      src="../../../static/images/empty.png"
    />
    <img v-else width="300px" src="../../../static/images/sempty.png" />
  </div>
</template>

<script>
export default {
  props: {
    bheight: {
      type: Number,
      default: 400
    },
    isShangyun: {
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/emptypage/index.vue